export default __webpack_public_path__ + "static/media/us.c95087e1.svg";